import React from 'react';
import {
    CircularProgressbar,
    CircularProgressbarWithChildren,
    buildStyles
} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

export class CircleLogo extends React.Component {

    constructor(props) {
        super(props)

    }


    render() {

        return (

            <div
                style={{
                    width: this.props.size,
                    height: this.props.size,
                    transform: `scale(${Math.max(Math.min(1 + (this.props.map.getZoom() - 8) * 0.4, 1), 0)}) `
                }}
            >
                <CircularProgressbar
                    value={this.props.value}
                    text={`${this.props.value}%`}
                    counterClockwise
                    background
                    backgroundPadding={6}
                    styles={buildStyles({
                        backgroundColor: "black",
                        textColor: this.props.color,
                        pathColor: this.props.color,
                        trailColor: "transparent",
                        textSize: '24px',

                    })}
                />
            </div>
        );
    }
}

